module.exports = __webpack_public_path__ + "static/img/office (5).95df03e9.jpg";